var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import TenantService from 'App/services/tenant';
import { displayTime, newSafeDate } from '../app/time-helpers';
import { deliveryOptions, DeliveryTypes } from '../order-fields';
export var getAllowedDeliveryOptions = function (restaurantDetails, canOrderRobot) {
    if (canOrderRobot === void 0) { canOrderRobot = false; }
    var allowedKeys = __spreadArray(__spreadArray([], __read((restaurantDetails.allowedDeliveryOptionKeys || [])), false), [
        DeliveryTypes.robot,
    ], false);
    var allowedDeliveryOptions = deliveryOptions.filter(function (option) {
        if (restaurantDetails && restaurantDetails.allowedDeliveryOptionKeys) {
            return allowedKeys.includes(option.name);
        }
        return true;
    });
    return canOrderRobot
        ? allowedDeliveryOptions
        : allowedDeliveryOptions.filter(function (opt) { return opt.name !== DeliveryTypes.robot; });
};
export var getAllowedPaymentOptions = function (restaurantDetails, selectedDelivery) {
    var isAvailableForCurrentRestaurant = function (option) {
        if (restaurantDetails && restaurantDetails.allowedPaymentOptionKeys) {
            return restaurantDetails.allowedPaymentOptionKeys.includes(option.name);
        }
        return true;
    };
    var isNonBlockedByDeliveryType = function (option) {
        if (selectedDelivery === DeliveryTypes.contactless ||
            selectedDelivery === DeliveryTypes.robot) {
            return option.isOnline;
        }
        if (restaurantDetails.allowedTakeoutPaymentOptionKeys &&
            selectedDelivery === DeliveryTypes.takeout) {
            return restaurantDetails.allowedTakeoutPaymentOptionKeys.includes(option.name);
        }
        if (restaurantDetails.allowedDeliveryPaymentOptionKeys &&
            selectedDelivery !== DeliveryTypes.takeout) {
            return restaurantDetails.allowedDeliveryPaymentOptionKeys.includes(option.name);
        }
        return true;
    };
    return TenantService.getAvailablePaymentOptions()
        .filter(isAvailableForCurrentRestaurant)
        .filter(isNonBlockedByDeliveryType);
};
export var getConfirmationTime = function (order) {
    return displayTime(newSafeDate(order.confirmed_at));
};
